/**
 * Calculate price with VAT applied if the company charges VAT.
 * @param {number|string} basePrice - The base price before VAT
 * @param {object} company - Company object with chargeVat and vatAmount
 * @returns {number} Price with VAT applied (or base price if no VAT)
 */
export const calculatePrice = (basePrice, company) => {
  const price = Number(basePrice)
  if (company?.chargeVat && company?.vatAmount) {
    const vatRate = Number(company.vatAmount)
    return price * (1 + vatRate / 100)
  }
  return price
}
